const modalTheme = {
  baseStyle: { dialog: { mx: 3, rounded: "0" } },
};

export default modalTheme;
